import { Defaults } from 'es-decorators'
import { View } from 'es6/components/view'
import { getTemplate } from 'helpers/template-helper'
import { okoPush } from 'helpers/oko-helpers'
import videojs from 'video.js'
require('videojs-flash')

/**
 * Вид для видео где угодно
 */
@Defaults({
  templateName: '',
  template: '',
  player: null,
  additionalOptions: ['templateName'],
})
export class BaseVideoView extends View {
  /**
   * @inheritDoc
   */
  run () {
    if (this.templateName) {
      this.template = getTemplate(this.templateName)
    }
  }

  /**
   * @inheritDoc
   * @param {string} modelOrSrc
   * @param {string} poster
   */
  render (modelOrSrc, poster) {
    if (this.template) {
      this.$el.html(this.template({
        modelOrSrc: modelOrSrc,
        poster: poster,
      }))
    }
    this.initPlayer()
  }

  /**
   * Отключение плеера, снятие всех обработчиков
   */
  destructPlayer () {
    // Проверяем наличие блока с видео
    const video = this.$('.video-js')
    if (video.length) {
      // Перестаем слушать события плеера перед удалением.
      if (this.trackingPlayback) {
        clearInterval(this.trackingPlayback)
      }
      this.player.off('play', this.sendData.bind(this))
      this.player.off('pause', this.sendData.bind(this))
      this.player.off('ended', this.sendData.bind(this))
      videojs(video[0]).dispose()
    }
  }

  /**
   * Подключение плеера
   */
  initPlayer () {
    // Проверяем наличие блока с видео в отрендеренном блоке
    const video = this.$('.video-js')
    if (video.length) {
      // инициализируем video.js
      this.player = videojs(video[0])
      this.player.ready(this.readyHandler.bind(this))
      this.player.on('error', this.errorHandler.bind(this))
      if (this.player.error()) {
        this.errorHandler()
        return
      }
      this.readyHandler()
      // По готовности слушаем события плеера для отправки в око.
      this.player.on('play', this.sendData.bind(this))
      this.player.on('pause', this.sendData.bind(this))
      this.player.on('ended', this.sendData.bind(this))
    }
  }

  /**
   * Удаление view, отключаем все плагины, удаляем коллбеки
   */
  destruct () {
    this.destructPlayer()
  }

  /**
   * Отправка событий в око
   * @param {Event} e
   */
  sendData (e) {
    let sid
    let type = e.type
    if (this.model && this.model.get('sid')) {
      sid = this.model.get('sid')
    }
    okoPush({
      'n': 'video',
      'action': type,
      'sid': sid,
    })

    if (e.type === 'play') {
      this.sendTime(sid)
      this.trackingPlayback = setInterval(() => {
        this.sendTime(sid)
      }, 10000)
    }
    if (e.type === 'pause') {
      if (this.trackingPlayback) {
        clearInterval(this.trackingPlayback)
      }
    }
  }

  /**
   * Перехват ошибок
   */
  errorHandler () {
  }

  /**
   * Обработка готовности плеера
   */
  readyHandler () {
  }

  /**
   * Отправка время видео в ОКО
   * @param {number} sid
   */
  sendTime (sid) {
    let time = parseInt(this.player.currentTime(), 10)
    okoPush({
      'n': 'video',
      'time': time,
      'sid': sid,
    })
  }
}
